/**
 * @generated SignedSource<<72906e81947dc5d47c9f5429e734d838>>
 * @relayHash 9e85dcc1f5052b15ad984ce04355a81b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b32a050756cd7c85fc5b8be21b06dd67137df07c58fb95dbd8b6376b34305d68

import type { ConcreteRequest, Query } from 'relay-runtime';
export type smartfieldsDropdownItemAdminToggleQuery$variables = {
  cloudId: string;
};
export type smartfieldsDropdownItemAdminToggleQuery$data = {
  readonly jira: {
    readonly applicationPropertiesByKey: ReadonlyArray<{
      readonly key: string;
      readonly value: string;
    }> | null | undefined;
  } | null | undefined;
};
export type smartfieldsDropdownItemAdminToggleQuery = {
  response: smartfieldsDropdownItemAdminToggleQuery$data;
  variables: smartfieldsDropdownItemAdminToggleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "jira.create.smart.fields.is-enabled"
    ]
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "value"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "smartfieldsDropdownItemAdminToggleQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "smartfieldsDropdownItemAdminToggleQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b32a050756cd7c85fc5b8be21b06dd67137df07c58fb95dbd8b6376b34305d68",
    "metadata": {},
    "name": "smartfieldsDropdownItemAdminToggleQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dd574875cb62c2e1fc5d67c9f05f7bcf";

export default node;
